
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { Getter, namespace } from "vuex-class";
import { SiteTreeNode } from "@/store/eventqueue/types"
import AlarmPoint from "./AlarmPoint.vue"
import AreaAlarmPoints from "./AreaAlarms.vue"
import AlarmPointFinder from "./AlarmPointFinder.vue"
import DevicesOnTest from "../DevicesOnTest.vue";
import { FeaturesList } from "@/store/types";
import { UserPermissions } from "@/store/types";
import { get } from "lodash";
import { BTab, BTabs } from "bootstrap-vue";
import { EventDetails } from "@/store/site-monitor/types";

    // Represents an area in the AreaTree
    export interface EventArea {
        id: number;
        label: string;
    }

    const Eventqueue = namespace("eventqueue");
    const AlarmPoints = namespace("alarmPoints");

    @Component({
        components: {
            VuePerfectScrollbar,
            "alarm-point": AlarmPoint,
            "alarm-point-finder": AlarmPointFinder,
            "area-alarm-points": AreaAlarmPoints,
            "devices-on-test": DevicesOnTest,
            "b-tabs": BTabs,
            "b-tab": BTab
        }
    })
    export default class AlarmPointManagerDialog extends Vue {
        $refs!: {
			alarmDialog: any;
			alarmPointFinder: AlarmPointFinder
        };

        @Getter("getFeaturesList") featuresList: FeaturesList;
        @Getter("getPermissions") private permissions: UserPermissions;

        @Eventqueue.Getter('getSiteTree') tree: SiteTreeNode[];
        @Eventqueue.Action sitesTreeGet: any;

        @AlarmPoints.State("selectedResponse") getSelectedResponse;
        @AlarmPoints.State("alarmPointManagerOpen") getAlarmPointManagerOpen;
        @AlarmPoints.Mutation setAlarmPointManagerOpen;
        @AlarmPoints.Mutation setSelectedResponse: any;

        @AlarmPoints.Mutation setSelectedArea: any;
        @AlarmPoints.State("selectedArea") selectedArea;

        @AlarmPoints.State("displayResponseId") getDisplayResponseId;

        @Prop() public eventDetails!: EventDetails;

        public eventArea: EventArea = {} as EventArea;
        private searchQuery: string = "";
        public currentTab: string = "alarm";

        public mounted(): void {
            this.setAlarmPointManagerOpen(false);
            this.setSelectedResponse(null);
        }

        @Watch("getAlarmPointManagerOpen")
		public async onGetAlarmPointManagerOpen(value: boolean, oldValue: boolean | null): Promise<void> {
            if (value) {
                this.setSelectedArea(null);
                if (this.eventDetails && this.eventDetails.groupID > 0 && !!this.eventDetails.siteTitle) {
                    this.eventArea = { id: this.eventDetails.groupID, label: this.eventDetails.siteTitle };
                }

                this.setSelectedResponse(null);
                if (this.$refs.alarmDialog && this.$refs.alarmDialog.show)
                    this.$refs.alarmDialog.show();
            } else {
                this.setSelectedResponse(null);
                if (this.$refs.alarmDialog && this.$refs.alarmDialog.hide)
                    this.$refs.alarmDialog.hide();
            }
        }

        public cancel(): void {
            this.resetSearch();
            this.setAlarmPointManagerOpen(false);
        }

        public groupFind(groupID: number): SiteTreeNode {
            const recursiveFind = (tree: SiteTreeNode) => {
                if (tree.group.groupID == groupID)
                    return tree;

                if (tree.subGroups && tree.subGroups.length > 0) {
                    let matchingSubgroup = null;
                    tree.subGroups.forEach((node: SiteTreeNode) => {
                        if (matchingSubgroup == null)
                            matchingSubgroup = recursiveFind(node);
                    });

                    return matchingSubgroup;
                }
            }

            let matchingGroup = null;
            this.tree.forEach((node: SiteTreeNode) => {
                if (matchingGroup == null)
                    matchingGroup = recursiveFind(node);
            });

            return matchingGroup;
        }

        public setTreeArmedStatus(response: any): void {
            let responseGroup = this.groupFind(response.groupID);
            if (responseGroup && responseGroup.contents && responseGroup.contents.responses) {

                let responses = responseGroup.contents.responses.filter((treeResponse) => treeResponse.responseID == response.responseID);

                responses.forEach((treeResponse) => {
                    treeResponse.armed = response.armed;
                });
            }
        }

		public onMaskedAlarm(result: any): void {
            if (result && result.response) {
				this.setTreeArmedStatus(result.response);

				if (this.$refs.alarmPointFinder) {
					this.$refs.alarmPointFinder.updateResponseStatus(result.response);
				}
            }
        }

        public onUnmaskedAlarm(result: any): void {
            if (result && result.response) {
				this.setTreeArmedStatus(result.response);

				if (this.$refs.alarmPointFinder) {
					this.$refs.alarmPointFinder.updateResponseStatus(result.response);
				}
            }
        }

        public backToGroup(): void {
            this.setSelectedResponse(null);
        }

        private get isDevicesOnTestEnabled(): boolean {
			return get(this.featuresList, ["Alarms", "AlarmPoints", "OnTest", "Devices"], false);
		}

        public get hasCanPutDevicesOnTestPermission(): boolean {
			return this.permissions.canPutDevicesOnTest;
        }

        public tabPressed(value: string): void {
            this.currentTab = value;
            this.searchQuery = "";
        }

        private get getSearchPlaceholder(): string {
            return this.currentTab === "alarm" ?
                "Search for an alarm" :
                "Search for a device";
        }

        private resetSearch(): void {
            this.searchQuery = "";
        }
    }
